import React from 'react';
import VideoPicker from '../video/VideoPicker';
import VideoSlots from '../video/VideoSlots';

/**
 * Videos mode of the Song panel (Lesson Dashboard pass 3 D3, 2026-09-28).
 * Moved from RightColumn: the three saved slots (Lyrics / Karaoke /
 * Performance, filled = play into the stage window, empty = add one),
 * **Change**, the inline picker and the video errors, each with Dismiss.
 * "Track from Karaoke / Performance" is now a SHORTCUT: `onMakeTrack(kind)`
 * opens Tracks mode at Add a track step 2 with that video set, rather than
 * queuing the job from here, so the teacher sees and confirms Remove vocals
 * before anything is made.
 */
const VideosPane = ({ song, video, videoTrack = null, onMakeTrack = null }) => (
	<div className="ld-rightcol__lyrics">
		{/* Saved videos, at EVERY width since pass 3 D3: the Song panel is the
		    column at 1200+ and the same component as a sheet below it, so the
		    slots, Change, the picker and the errors are reachable on an iPad and a
		    phone too. "Show" plays into the second screen (the strip's Second
		    screen control opens it). */}
		<div className="ld-rightcol__sec">
			<h4 className="ld-rightcol__sechead">Videos · second monitor</h4>
			<VideoSlots
				videos={video?.videos}
				onPlay={video?.open}
				onEdit={video?.edit}
				trackStateFor={videoTrack?.stateFor}
				onMakeTrack={onMakeTrack || videoTrack?.make}
			/>
			{videoTrack?.error && (
				<div className="ld-dismissable-error" role="alert">
					<p className="ld-rightcol__status ld-rightcol__status--error">
						The track could not be started. Please tell Anthony right away.
						<span className="ld-vslots__detail">{videoTrack.error}</span>
					</p>
					{videoTrack.clearError && (
						<button type="button" className="ld-dismiss" onClick={videoTrack.clearError}>
							Dismiss
						</button>
					)}
				</div>
			)}
		</div>

		{video?.error && !video.editingKind && (
			<div className="ld-dismissable-error" role="alert">
				<p className="ld-rightcol__status ld-rightcol__status--error">{video.error}</p>
				{video.clearError && (
					<button type="button" className="ld-dismiss" onClick={video.clearError}>
						Dismiss
					</button>
				)}
			</div>
		)}

		{/* Keyed by song: the picker holds its query and results in its own
		    state, so without a key a picker left open while the song changes
		    keeps the LAST song's results, and one of them can be saved onto
		    this song. Defensive: Addison's Placido carried another student's
		    "On My Own" (2026-10-22) by a path not yet proven. A new song gets a
		    fresh search. */}
		{video?.editingKind && (
			<VideoPicker
				key={song?.id || 'none'}
				song={song}
				kind={video.editingKind}
				draft={video.draft}
				setDraft={video.setDraft}
				error={video.error}
				// The url is passed EXPLICITLY rather than through setDraft
				// first: `save` closes over `draft`, so a setDraft/save pair
				// in one handler saves the previous pick. See useSongVideo.
				onPickUrl={(url) => video.save(url)}
				onSaveDraft={() => video.save()}
				onCancel={video.cancel}
			/>
		)}
	</div>
);

export default VideosPane;
